<section role="region" aria-label="Root application section">
  <h1 id="referral-dashboard" class="sr-only" tabindex="-1" aria-hidden="false" role="heading" aria-level="1"
  data-injected-h1="true">Referral Dashboard</h1>
</section>
<mnc-shared-services></mnc-shared-services>

@if (isPermissionsListLoaded) {
  <div class="content-container">
    <router-outlet />
  </div>
}
<app-bulk-toast></app-bulk-toast>

<p-toast key="httpAction" position="bottom-left"></p-toast>
<p-confirmDialog
  header="Confirmation"
  appendTo="body"
  styleClass="referral-dashboard-modal"
  acceptLabel="Yes"
  rejectLabel="No"
/>
